"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleDriveMoveFile = exports.googleDriveMoveFileResultSchema = exports.googleDriveMoveFileArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.googleDriveMoveFileArgsSchema = (0, common_1.PipedreamNodeArgsSchema)('move-file', zod_1.z.object({
    fileId: zod_1.z.string().describe('The file to be moved, referenced by its id'),
    folderId: zod_1.z.string().describe('The folder to move the file to, referenced by its id'),
}));
exports.googleDriveMoveFileResultSchema = (0, common_1.PipedreamNodeResultSchema)(zod_1.z.object({}));
exports.googleDriveMoveFile = (0, common_1.createToolMetadata)({
    id: 'googleDriveMoveFile',
    displayName: 'Google Drive Move File',
    displayDescription: 'Move a file to a target folder by id in Google Drive',
    category: 'integration',
    color: common_1.BRAND_COLORS.GOOGLE_DRIVE,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GOOGLE_DRIVE),
    icon: 'google_drive',
    argsSchema: exports.googleDriveMoveFileArgsSchema,
}, exports.googleDriveMoveFileResultSchema);
